export enum Module {
	RATES= 'RATES',
	PARITY = 'PARITY',
	MARKET_INSIGHT = 'MARKET_INSIGHT',
	FLEXI_SETS= 'FLEXI_SETS',
	RATES_RMS = 'RATES_RMS',
	PRICING_AUTOMATION = 'PRICING_AUTOMATION',
	PRICE_RECOMMENDATION = 'PRICE_RECOMMENDATION'
}